import React from 'react'
import Layout from '../components/Layout'
import ContactUsBanner from '../components/ContactUs/ContactUsBanner'
import GetInTouch from '../components/ContactUs/GetInTouch'

function ContactUs() {
  return (
    <Layout>
      <ContactUsBanner />
      <GetInTouch />
    </Layout>
  )
}

export default ContactUs